<template>
  <div class="scrollToTopBar">
    <tk-link @click="scrollToTop" />
  </div>
</template>

<script>
import TkLink from '../../atoms/TkLink/TkLink'

export default {
  name: 'TkScrollToTopBar',
  components: {
    TkLink,
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      })
    },
  },
}
</script>

<style lang="scss">
@import '@ota-frontend/ui/src/scss/components/TkScrollToTopBar.scss';
</style>
